import { v4 as uuid } from "uuid";
import { useForm } from "react-hook-form";
import Card from "../../../components/card/card";
import { AddPetDetailsStyled } from "./pets.styles";
import { useContext, useEffect, useState } from "react";
import {
  createUserPet,
  getAllUserBreeds,
  getAllUserGenders,
  getAllUserSpecies,
} from "../../../../../actions";
import { useAppDispatch } from "../../../../../store/hooks";
import { addNotification } from "../../../../../store/slices/ui-slice";
import {
  USER_APPOINTMENT_ACTIONS,
  UserAppointmentContext,
} from "../../../context/user-appointment-context";
import SelectFormField from "../../../../../components/form-fields/select-field/select-form-field";
import TextInputFormField from "../../../../../components/form-fields/text-input-field/text-input-form-field";
import DateFormField from "../../../../../components/form-fields/date-field/date-form-field";
import {
  getParsedBreeds,
  getParsedGenders,
  getParsedSpecies,
} from "./pets.utils";
import dayjs from "dayjs";

const AddPet = () => {
  const {
    state: { activeStep, selectedClientAccount },
    userDispatcher,
  } = useContext(UserAppointmentContext);
  const { control, handleSubmit, watch } = useForm();
  const [loading, setLoading] = useState(false);
  const [loadingConfirmBtn, setLoadingConfirmBtn] = useState(false);
  const [species, setSpecies] = useState<any[]>([]);
  const [breeds, setBreeds] = useState<any[]>([]);
  const [genders, setGenders] = useState<any[]>([]);

  const dispatch = useAppDispatch();
  const formValues = watch();

  const onAddPet = async (formValues: any) => {
    try {
      const { breed, specie, gender, petName, birthdate } = formValues;
      const integrationId = selectedClientAccount?.integration_id;

      setLoadingConfirmBtn(true);
      const petPayload = {
        client_id: integrationId,
        name: petName,
        breeds: [
          {
            id: breed,
          },
        ],
        species: {
          id: specie,
        },
        sex: {
          id: gender,
        },
        birthdate: dayjs(birthdate).format("YYYY-MM-DDTHH:mm:ssZ"),
        status: "active",
      };
      await createUserPet(petPayload);
      userDispatcher({
        type: USER_APPOINTMENT_ACTIONS.SET_ACTIVE_STEP,
        payload: activeStep + 1,
      });
    } catch (err: any) {
      dispatch(
        addNotification({
          id: uuid(),
          type: "error",
          message: err.message || "An unexpected error occurred.",
        })
      );
    } finally {
      setLoadingConfirmBtn(false);
    }
  };

  const fetchBreeds = async (value: number) => {
    const response = await getAllUserBreeds(value);
    const parsedBreeds = getParsedBreeds(response?.data?.data || []);
    setBreeds(parsedBreeds);
  };

  const handleSpecieChange = async (event: any) => {
    const value = event?.target.value;
    setLoading(true);
    try {
      fetchBreeds(value);
    } catch (err: any) {
      dispatch(
        addNotification({
          id: uuid(),
          type: "error",
          message: err.message || "An unexpected error occurred.",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchSpecies = async () => {
      setLoading(true);
      try {
        // Fetch species
        const response = await getAllUserSpecies();
        const parsedSpecies = getParsedSpecies(response?.data?.data || []);
        setSpecies(parsedSpecies);

        // Fetch genders
        const gendersResponse = await getAllUserGenders();
        const parsedGenders = getParsedGenders(
          gendersResponse?.data?.data || []
        );
        setGenders(parsedGenders);
      } catch (err: any) {
        dispatch(
          addNotification({
            id: uuid(),
            type: "error",
            message: err.message || "An unexpected error occurred.",
          })
        );
      } finally {
        setLoading(false);
      }
    };

    fetchSpecies();
  }, [dispatch]);

  useEffect(() => {
    if (formValues?.specie) fetchBreeds(formValues?.specie);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Card
      title={"Enter pet info"}
      btnTitle={"Add Pet"}
      onHandleClick={handleSubmit(onAddPet)}
      progress={activeStep * 5}
      showBackButton
      handleBack={() =>
        userDispatcher({
          type: USER_APPOINTMENT_ACTIONS.SET_ACTIVE_STEP,
          payload: activeStep - 1,
        })
      }
      isLoadingConfirmBtn={loadingConfirmBtn}
    >
      <AddPetDetailsStyled className="form">
        <TextInputFormField
          name="petName"
          control={control}
          label="Name"
          placeholder="Enter here"
        />
        <SelectFormField
          name="specie"
          control={control}
          label="Specie"
          placeholder="Enter here"
          options={species}
          customOnChange={handleSpecieChange}
        />
        <SelectFormField
          name="gender"
          control={control}
          label="Gender"
          placeholder="Enter here"
          options={genders}
        />
        <SelectFormField
          name="breed"
          control={control}
          label="Breed"
          placeholder="Enter here"
          options={breeds}
        />
        <DateFormField
          name="birthdate"
          control={control}
          label="Date of Birth"
        />
      </AddPetDetailsStyled>
    </Card>
  );
};

export default AddPet;
